import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import QuoteModal from '../../components/feature/QuoteModal';
import HeroCarousel from '../../components/feature/HeroCarousel';
import ServiceModal, { ServiceItem } from '../../components/feature/ServiceModal';
import { useSeoMeta } from '@/hooks/useSeoMeta';
import ShowreelSection from '@/components/feature/ShowreelSection';
import SocialSidebar from '@/components/feature/SocialSidebar';
import PortfolioLightbox, { PortfolioItem } from '@/components/feature/PortfolioLightbox';
import { CONTACT, decodeContact, whatsappHref } from '@/lib/contactProtect';

const TR_SLIDES = [
  {
    subtitle: 'Profesyonel Etkinlik Çözümleri',
    title: 'Vizyonunuzu Deneyime Dönüştürüyoruz',
    description:
      '35 yılı aşkın deneyimimizle Türkiye\'den Avrupa\'ya, Orta Doğu\'dan Kafkasya\'ya uzanan geniş bir coğrafyada dünya standartlarında etkinlik yönetimi ve teknik prodüksiyon hizmetleri sunuyoruz.',
    image: 'https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/7fe880b7ed4d0915e58be95dc2eb2824.jfif',
  },
  {
    subtitle: 'Teknik Mükemmellik',
    title: 'Kusursuz Teknik Prodüksiyon',
    description:
      'Ses sistemlerinden ışık tasarımına, video prodüksiyondan sahne kurulumuna kadar — uzman teknik ekibimiz her detayın mükemmel şekilde hayata geçirilmesini sağlar.',
    image: 'https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/88a241c59883f830429183d4ef769bd3.jfif',
  },
  {
    subtitle: 'Global Erişim',
    title: '17+ Ülkede Etkinlik Deneyimi',
    description:
      'Türkiye, Macaristan, BAE, Almanya, Avusturya, Suudi Arabistan, Gürcistan, Azerbaycan ve daha fazlasında faaliyet göstererek yerel uzmanlığı küresel bir perspektifle sunuyoruz.',
    image: 'https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/3a9d5a33d4f40290002e787392d5bfac.jfif',
  },
  {
    subtitle: 'Sektör Liderlerinin Güveni',
    title: '500\'den Fazla Etkinlik Tamamlandı',
    description:
      'NATO Zirvelerinden Huawei Teknoloji Zirvelerine, Coca-Cola turlarından farmasötik kongrelere — dünyanın önde gelen markalarının güvenini kazandık.',
    image: 'https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/c6534210e3a604c303c99e2a10d64a17.jfif',
  },
  {
    subtitle: 'Uçtan Uca Hizmet',
    title: 'Konseptten Uygulamaya Kadar',
    description:
      'Mekan seçimi, lojistik, AV kurulumu, canlı koordinasyon ve etkinlik sonrası medya prodüksiyonu dahil her şeyi biz yönetiyoruz — siz sadece vizyonunuza odaklanın.',
    image: 'https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/ce6c19bec576ecf4f881f0cd130305a3.jfif',
  },
  {
    subtitle: 'Başarınızda Ortağınız',
    title: '7/24 Destek ve Özel Ekip',
    description:
      'Özel ekibimiz, ilk planlama görüşmesinden son perdeye kadar etkinliğinizin sorunsuz ilerlemesi için her an yanınızda.',
    image: 'https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/138555603754b0beeffc9f2035e517f0.jfif',
  },
  {
    subtitle: 'Vizyonun Arkasındaki Ekiple Tanışın',
    title: 'Aile, Tutku ve Adanmışlık',
    description:
      'Her büyük etkinliğin arkasında gerçekten önem veren bir ekip vardır. Sunduğumuz her projeye tutku, yaratıcılık ve özveri katan insanlarla tanışın.',
    image: 'https://storage.readdy-site.link/project_files/9e58cc21-40d2-414d-b7dd-441fa32130a9/3bf2c6e4-476e-493b-829d-1563efc1f1a7_A5BDC899-91CB-4038-BC89-433CE131BC45_1_105_c.jpeg?v=f5bc227e18cc9c95b97a462dba01784a',
  },
];

const TR_PORTFOLIO: PortfolioItem[] = [
  { title: '2025 Vertigo Academy', location: 'Budapeşte, Macaristan', category: 'Farmasötik Kongre', image: 'https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/88a241c59883f830429183d4ef769bd3.jfif' },
  { title: 'Huawei OTF 2024', location: 'İstanbul, Türkiye', category: 'Teknoloji Zirvesi', image: 'https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/7fe880b7ed4d0915e58be95dc2eb2824.jfif' },
  { title: 'Hytera Küresel Ortak Zirvesi MEA 2024', location: 'Dubai, BAE', category: 'Kurumsal Zirve', image: 'https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/3a9d5a33d4f40290002e787392d5bfac.jfif' },
  { title: '2023 Prag Nutricia EXPO 2.0 Etkinliği', location: 'Prag, Çek Cumhuriyeti', category: 'Tıbbi Konferans', image: 'https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/138555603754b0beeffc9f2035e517f0.jfif' },
  { title: 'Coca-Cola Türkiye Sound Wave Turları', location: 'Türkiye Geneli', category: 'Müzik Turu', image: 'https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/ce6c19bec576ecf4f881f0cd130305a3.jfif' },
  { title: '2004 NATO Zirvesi İstanbul', location: 'İstanbul, Türkiye', category: 'Uluslararası Zirve', image: 'https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/c6534210e3a604c303c99e2a10d64a17.jfif' },
];

const TR_BADGES = [
  { icon: 'ri-tools-line', text: 'Öz Teknik Ekipman' },
  { icon: 'ri-global-line', text: 'Geniş İş Ortağı Ağı' },
  { icon: 'ri-translate-2', text: 'Çok Uluslu Hizmet' },
  { icon: 'ri-24-hours-line', text: '7/24 Destek' },
];

const TR_SERVICE_SLUGS: Record<string, string> = {
  'Teknik Prodüksiyon & AV': 'technical-production-av',
  'Kurumsal Etkinlikler & Konferanslar': 'corporate-events-conferences',
  'Sahne Tasarımı & Işık': 'stage-design-lighting',
  'DMC / Destinasyon Hizmetleri': 'dmc-destination-services',
  'Hibrit / Sanal Etkinlikler': 'hybrid-virtual-events',
  'Ürün Lansmanları & Marka Aktivasyonları': 'product-launches-brand-activations',
  'Ödül Törenleri & Galalar': 'award-ceremonies-galas',
  'Etkinlik Sonrası Medya Prodüksiyon': 'post-event-media-production',
};

const TR_SERVICES: ServiceItem[] = [
  {
    icon: 'ri-lightbulb-line',
    title: 'Etkinlik Stratejisi & Planlama',
    description: 'Vizyondan zaman çizelgesine.',
    detail:
      'Etkinliğinizin tüm yol haritasını oluşturuyoruz — ilk konsept ve bütçe planlamasından detaylı zaman çizelgelerine, tedarikçi koordinasyonuna ve acil durum stratejilerine kadar. Her başarılı etkinlik sağlam bir planla başlar.',
  },
  {
    icon: 'ri-mic-line',
    title: 'Teknik Prodüksiyon & AV',
    description: 'Ses, ışık, video ve sahne — kusursuz entegrasyon.',
    detail:
      'Bünyemizdeki teknik ekibimiz tüm görsel-işitsel gereksinimleri karşılar: profesyonel ses sistemleri, dinamik ışık düzenekleri, LED video duvarları, projeksiyon haritalama ve tam sahne kurulumu. Maksimum güvenilirlik için kendi ekipmanlarımıza sahibiz.',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Mekan Seçimi & Lojistik',
    description: 'Doğru mekanı bulur, tüm lojistiği yönetiriz.',
    detail:
      'İstanbul\'daki ikonik balo salonlarından Budapeşte\'deki kongre merkezlerine ve Dubai\'deki sahil mekanlarına kadar — etkinliğiniz için mükemmel mekanı bulur, müzakere eder ve tüm yerinde lojistiği yönetiriz.',
  },
  {
    icon: 'ri-live-line',
    title: 'Canlı Etkinlik Yönetimi',
    description: 'Yerinde koordinasyon, kusursuz uygulama.',
    detail:
      'Deneyimli etkinlik yöneticilerimiz kurulumdan söküme kadar sahada olup her ekibi, tedarikçiyi ve zaman çizelgesini koordine ederek etkinliğinizin ölçeği ne olursa olsun sorunsuz ilerlemesini sağlar.',
  },
  {
    icon: 'ri-global-line',
    title: 'DMC / Destinasyon Hizmetleri',
    description: 'Kapsamlı destinasyon yönetimi ve yerel uzmanlık.',
    detail:
      'Destinasyon Yönetim Şirketi olarak kapsamlı yerel hizmetler sunuyoruz: otel seçimi, havalimanı transferleri, rehberli turlar, kültürel deneyimler ve faaliyet gösterdiğimiz her ülkede tam kara lojistiği.',
  },
  {
    icon: 'ri-computer-line',
    title: 'Hibrit / Sanal Etkinlikler',
    description: 'Fiziksel ve dijital kitleleri bir araya getirin.',
    detail:
      'Profesyonel canlı yayın, etkileşimli platformlar, sanal ağ kurma ve yayın kalitesinde prodüksiyon ile hibrit ve tamamen sanal etkinlikler tasarlayıp üretiyoruz; dünya genelindeki kitleleri birbirine bağlıyoruz.',
  },
  {
    icon: 'ri-palette-line',
    title: 'Sahne Tasarımı & Işık',
    description: 'Büyüleyici yaratıcı sahne ve aydınlatma çözümleri.',
    detail:
      'Yaratıcı ekibimiz, minimalist kurumsal düzenlemelerden ayrıntılı tiyatral prodüksiyonlara kadar etkileyici sahne ortamları tasarlar — en son LED teknolojisi, hareketli ışıklar ve özel dekor unsurlarını kullanarak.',
  },
  {
    icon: 'ri-camera-line',
    title: 'Etkinlik Sonrası Medya Prodüksiyon',
    description: 'Profesyonel fotoğraf ve video hizmetleri.',
    detail:
      'Her anı profesyonel fotoğrafçılık ve sinematik video çekimiyle ölümsüzleştiriyoruz; etkinliğinizin ardından düzenlenmiş öne çıkan anlar, tam etkinlik kayıtları ve sosyal medya içerik paketleri sunuyoruz.',
  },
  {
    icon: 'ri-group-line',
    title: 'Kurumsal Etkinlikler & Konferanslar',
    description: 'Profesyonel kurumsal toplantılar ve iş konferansları.',
    detail:
      'Küçük yönetim kurulu toplantılarından büyük ölçekli uluslararası konferanslara kadar kurumsal etkinliklerin her boyutunu yönetiyoruz — AV, ikram koordinasyonu, simultane tercüme ve delege yönetimi dahil.',
  },
  {
    icon: 'ri-music-line',
    title: 'Eğlence & Sanatçı Yönetimi',
    description: 'Kapsamlı sanatçı booking ve eğlence koordinasyonu.',
    detail:
      'Eğlencenin tüm boyutlarını yönetiyoruz — sanatçı booking, sözleşme müzakeresi, teknik rider\'lar, sahne arkası yönetimi ve yerinde koordinasyon — kusursuz bir performans deneyimi sağlıyoruz.',
  },
  {
    icon: 'ri-award-line',
    title: 'Ödül Törenleri & Galalar',
    description: 'Şık ödül törenleri ve prestijli seremoniler.',
    detail:
      'Sofistike sahne tasarımı, özel ödüller, kırmızı halı düzenlemeleri, canlı eğlence ve kusursuz etkinlik akışı yönetimiyle unutulmaz ödül törenleri ve gala yemekleri üretiyoruz.',
  },
  {
    icon: 'ri-presentation-line',
    title: 'Ürün Lansmanları & Marka Aktivasyonları',
    description: 'Etkili ürün tanıtımları ve etkileyici marka deneyimleri.',
    detail:
      'Yaratıcı sahne tasarımı, deneyimsel tasarım, medya yayını koordinasyonu ve hedef kitle etkileşim stratejilerini bir araya getirerek kalıcı izler bırakan ürün lansmanları ve marka aktivasyonları yaratıyoruz.',
  },
  {
    icon: 'ri-calendar-event-line',
    title: 'Festival & Kültürel Etkinlikler',
    description: 'Büyük ölçekli festivaller ve kültürel kutlamalar.',
    detail:
      'Müzik festivallerinden kültürel miras etkinliklerine kadar tam teknik altyapı, kalabalık yönetimi planlaması ve çok sahneli koordinasyonla büyük ölçekli açık ve kapalı alan prodüksiyonlarını yönetiyoruz.',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Fuar & Ticaret Sergileri',
    description: 'Profesyonel fuar yönetimi ve ticaret sergisi koordinasyonu.',
    detail:
      'Fuar standları, ticaret fuarı lojistiği ve ürün sergi ortamları tasarlayıp yönetiyoruz — stand kurulumundan ziyaretçi akışı yönetimine ve potansiyel müşteri yakalama sistemlerine kadar her şeyi kapsıyoruz.',
  },
  {
    icon: 'ri-team-line',
    title: 'Takım Çalışması & Motivasyon Etkinlikleri',
    description: 'Etkileyici takım aktiviteleri ve motivasyonel kurumsal retreatlar.',
    detail:
      'Küresel destinasyonlarımızda macera aktivitelerinden lüks retreatlara kadar motivasyon sağlayan, ilham veren ve takım bağlarını güçlendiren yaratıcı takım çalışması programları ve teşvik seyahati deneyimleri tasarlıyoruz.',
  },
  {
    icon: 'ri-graduation-cap-line',
    title: 'Eğitim & Seminer Etkinlikleri',
    description: 'Atölye çalışmaları, seminerler ve eğitim konferansı yönetimi.',
    detail:
      'Küçük atölye çalışmalarından büyük ölçekli eğitim konferanslarına kadar her boyuttaki eğitim etkinliğini yönetiyoruz — profesyonel AV, breakout oda yönetimi, e-öğrenme entegrasyonu ve katılımcı etkileşim araçlarıyla.',
  },
];

export default function HomeTR() {
  const navigate = useNavigate();
  const [showCallOptions, setShowCallOptions] = useState(false);
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);
  const [selectedService, setSelectedService] = useState<ServiceItem | null>(null);

  useSeoMeta({
    lang: 'tr',
    canonicalPath: '/tr',
    title: 'Can ÖZEN Teknik Prodüksiyon | Kurumsal Etkinlik AV Hizmetleri İstanbul Budapeşte Dubai',
    description:
      "Türkiye, Avrupa ve Dubai'de kurumsal etkinlikler için profesyonel AV ve teknik prodüksiyon hizmetleri. Ses sistemleri, ışık, video prodüksiyon, sahne tasarımı, havalimanı transferleri ve etkinlik lojistiği. 35+ yıl deneyim.",
    keywords:
      'AV hizmetleri Türkiye, teknik prodüksiyon İstanbul, kurumsal etkinlik AV Avrupa, ses sistemleri ışık Türkiye, etkinlik lojistiği Dubai',
    ogLocale: 'tr_TR',
  });

  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'conversion', { send_to: 'AW-17649667115/-OOwCNr32IwcEKuYguBB' });
    }
  }, []);

  useEffect(() => {
    const siteUrl = (import.meta.env.VITE_SITE_URL || 'https://example.com') + '/tr';
    const baseSiteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const webPageSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Can ÖZEN Teknik Prodüksiyon | Kurumsal Etkinlik AV Hizmetleri İstanbul Budapeşte Dubai',
      description: 'Türkiye, Avrupa ve Dubai\'de kurumsal etkinlikler için profesyonel AV ve teknik prodüksiyon hizmetleri. 35+ yıl deneyim.',
      url: siteUrl,
      inLanguage: 'tr',
      dateModified: '2026-03-23',
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [{ '@type': 'ListItem', position: 1, name: 'Ana Sayfa', item: siteUrl }],
      },
    };

    const localBusinessSchema = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'CSG The Event Company & IEM101 International',
      alternateName: 'Can ÖZEN Teknik Prodüksiyon',
      url: baseSiteUrl,
      logo: 'https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/afb0395a8f917252ae1628849c248ce7.png',
      image: 'https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/afb0395a8f917252ae1628849c248ce7.png',
      description: 'Türkiye, Avrupa ve Dubai\'de kurumsal etkinlikler için profesyonel AV ve teknik prodüksiyon hizmetleri. 35+ yıl deneyim.',
      // Telefon semadan cikarildi, bkz. lib/contactProtect.ts
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Tomtom Mah. İstiklal Cad. No:189 Kat:2 Daire:3',
        addressLocality: 'Beyoğlu, İstanbul',
        addressRegion: 'İstanbul',
        addressCountry: 'TR',
      },
      geo: { '@type': 'GeoCoordinates', latitude: 41.0082, longitude: 28.9784 },
      sameAs: [
        'https://www.linkedin.com/in/can-%C3%B6zen-8b15667/',
        'https://www.instagram.com/csgtheeventcompany/',
      ],
      priceRange: '$$',
      areaServed: ['Türkiye', 'Macaristan', 'BAE', 'Almanya', 'Avusturya', 'Suudi Arabistan', 'Gürcistan', 'Azerbaycan'],
    };

    const organizationSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'CSG The Event Company & IEM101 International',
      alternateName: ['Can ÖZEN Teknik Prodüksiyon', 'CSG Etkinlik Şirketi', 'IEM101'],
      url: baseSiteUrl,
      logo: 'https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/afb0395a8f917252ae1628849c248ce7.png',
      description: 'Türkiye, Avrupa ve Dubai\'de kurumsal etkinlikler için profesyonel AV ve teknik prodüksiyon hizmetleri. 35+ yıl deneyim.',
      foundingDate: '1989',
      founder: { '@type': 'Person', name: 'Can Özen' },
      address: [
        {
          '@type': 'PostalAddress',
          streetAddress: 'Tomtom Mah. İstiklal Cad. No:189 Kat:2 Daire:3',
          addressLocality: 'Beyoğlu',
          addressRegion: 'İstanbul',
          addressCountry: 'TR',
          name: 'İstanbul Ofisi',
        },
        {
          '@type': 'PostalAddress',
          streetAddress: 'Föld utca 53',
          addressLocality: 'Budapeşte',
          postalCode: '1032',
          addressCountry: 'HU',
          name: 'Budapeşte Ofisi',
        },
      ],
      contactPoint: [
        {
          '@type': 'ContactPoint',
          // Telefon semadan cikarildi, bkz. lib/contactProtect.ts
          contactType: 'customer service',
          areaServed: ['TR', 'ME', 'EU'],
          availableLanguage: ['Turkish', 'English'],
        },
      ],
      sameAs: [
        'https://www.linkedin.com/in/can-%C3%B6zen-8b15667/',
        'https://www.instagram.com/csgtheeventcompany/',
      ],
      serviceArea: { '@type': 'Place', name: 'Avrupa, Orta Doğu, Kafkasya' },
    };

    const serviceSchema = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Kurumsal Etkinlikler için AV ve Teknik Prodüksiyon Hizmetleri',
      provider: { '@type': 'Organization', name: 'CSG The Event Company & IEM101 International' },
      serviceType: 'AV Hizmetleri',
      description: 'Ses sistemleri, ışık, video prodüksiyon, sahne tasarımı ve havalimanı transferleri dahil kapsamlı lojistik ile kurumsal etkinlikler için profesyonel görsel-işitsel hizmetler.',
      areaServed: [
        { '@type': 'Country', name: 'Türkiye' },
        { '@type': 'Country', name: 'Macaristan' },
        { '@type': 'Country', name: 'Birleşik Arap Emirlikleri' },
        { '@type': 'Country', name: 'Almanya' },
        { '@type': 'Country', name: 'Avusturya' },
        { '@type': 'Country', name: 'Suudi Arabistan' },
        { '@type': 'Country', name: 'Gürcistan' },
        { '@type': 'Country', name: 'Azerbaycan' },
      ],
    };

    const personSchema = {
      '@context': 'https://schema.org',
      '@type': 'Person',
      name: 'Can Özen',
      jobTitle: 'Kurucu & CEO',
      worksFor: { '@type': 'Organization', name: 'CSG The Event Company & IEM101 International' },
      description: '35+ yıl kurumsal etkinlik deneyimiyle AV ve teknik prodüksiyon uzmanı.',
      sameAs: ['https://www.linkedin.com/in/can-%C3%B6zen-8b15667/'],
    };

    const addSchema = (schema: object, id: string) => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = id;
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    };

    addSchema(webPageSchema, 'tr-webpage-schema');
    addSchema(localBusinessSchema, 'tr-localbusiness-schema');
    addSchema(organizationSchema, 'tr-organization-schema');
    addSchema(serviceSchema, 'tr-service-schema');
    addSchema(personSchema, 'tr-person-schema');

    return () => {
      ['tr-webpage-schema', 'tr-localbusiness-schema', 'tr-organization-schema', 'tr-service-schema', 'tr-person-schema'].forEach((id) => {
        const s = document.getElementById(id);
        if (s) s.remove();
      });
    };
  }, []);

  const handleCallClick = () => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'phone_call_button_click', { event_category: 'engagement', event_label: 'header_call_button', value: 1 });
    }
    setShowCallOptions(true);
  };

  const handlePhoneCall = () => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'phone_call_direct', { event_category: 'conversion', event_label: 'direct_phone_call', value: 1 });
      window.gtag('event', 'conversion', { send_to: 'AW-17649667115/FS49CJyah64bEKuYguBB' });
    }
    window.location.href = `tel:${decodeContact(CONTACT.istanbulPhoneRaw)}`;
    setShowCallOptions(false);
  };

  const handleWhatsAppCall = () => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'whatsapp_call', { event_category: 'conversion', event_label: 'whatsapp_contact', value: 1 });
    }
    window.open(whatsappHref(), '_blank');
    setShowCallOptions(false);
  };

  const handleAnalyticsAccess = () => {
    navigate('/analytics');
  };

  return (
    <div className="min-h-screen bg-black text-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <SocialSidebar lang="tr" />
      <Header lang="tr" />

      {/* Hero Carousel */}
      <HeroCarousel
        slides={TR_SLIDES}
        onQuoteOpen={() => setIsQuoteOpen(true)}
        onCallClick={handleCallClick}
        ctaQuote="Teklif Talep Et"
        ctaCall="Hemen Ara"
        badges={TR_BADGES}
      />

      {/* About Section */}
      <section id="about" className="py-20 bg-gradient-to-b from-gray-900 to-black">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6">
                Hikayemiz &amp;
                <span className="text-yellow-400"> Vizyonumuz</span>
              </h2>
              <div className="space-y-4 text-gray-300">
                <p className="text-lg">
                  Yolculuğum 1989 yılında bir AV teknisyeni olarak başladı. Yıllar içinde tutkumu büyüttüm ve 1996'da AVS İletişim'i kurdum. 2002'de Türkiye genelinde ulusal ve uluslararası projeler yürüten CSG The Event Company'yi hayata geçirdim.
                </p>
                <p className="text-lg">
                  2020'de Budapeşte'ye genişleyerek{' '}
                  <strong className="text-yellow-400">IEM101 International Kft</strong>'yi kurdum; operasyonlarımızı Avrupa ve ötesine taşıdım. İstanbul'daki CSG Teknik Prodüksiyon A.Ş. ve Macaristan'daki IEM101 aracılığıyla konseptten uygulamaya kadar eşsiz bir etkinlik mükemmeliyeti sunuyoruz.
                </p>
              </div>
              <div className="mt-8 grid grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-yellow-400">35+</div>
                  <div className="text-sm text-gray-400">Yıllık Deneyim</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-yellow-400">500+</div>
                  <div className="text-sm text-gray-400">Tamamlanan Etkinlik</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-yellow-400">15+</div>
                  <div className="text-sm text-gray-400">Ülke</div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/44df2fb83f62b32263643d78e10a35f8/b075e0d390815ed30f85d3182066e5d5.png"
                alt="Can Özen ve ekibi - CSG The Event Company"
                className="rounded-2xl shadow-2xl object-cover object-top w-full h-96 lg:h-[500px]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-black">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Ne Yapıyoruz &amp;
              <span className="text-yellow-400"> Neler Sunuyoruz</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Konseptten uygulamaya kadar, vizyonunuzu unutulmaz deneyimlere dönüştüren kapsamlı etkinlik çözümleri sunuyoruz.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {TR_SERVICES.map((service, index) => {
              const slug = TR_SERVICE_SLUGS[service.title];
              const cardContent = (
                <>
                  <div className="w-12 h-12 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-lg flex items-center justify-center mb-4">
                    <i className={`${service.icon} text-xl text-black`}></i>
                  </div>
                  <h3 className="text-lg font-semibold mb-3 text-white">{service.title}</h3>
                  <p className="text-gray-400 text-sm mb-4">{service.description}</p>
                  <span className="text-yellow-400 text-xs font-semibold flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                    Detaylar <i className="ri-arrow-right-line"></i>
                  </span>
                </>
              );
              return slug ? (
                <Link
                  key={index}
                  to={`/tr/hizmetler/${slug}`}
                  className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-xl p-6 hover:border-yellow-400/50 transition-all duration-300 hover:scale-105 cursor-pointer group block"
                >
                  {cardContent}
                </Link>
              ) : (
                <div
                  key={index}
                  className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-xl p-6 hover:border-yellow-400/50 transition-all duration-300 hover:scale-105 cursor-pointer group"
                  onClick={() => setSelectedService(service)}
                >
                  {cardContent}
                </div>
              );
            })}
          </div>
          <div className="text-center mt-10">
            <Link
              to="/tr/hizmetler"
              className="inline-flex items-center gap-2 px-8 py-3 border border-yellow-400/50 text-yellow-400 font-semibold rounded-lg hover:bg-yellow-400/10 transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-grid-line"></i>
              Tüm Hizmetleri Gör
            </Link>
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section id="portfolio" className="py-20 bg-gradient-to-b from-gray-900 to-black">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Seçili
              <span className="text-yellow-400"> Projeler</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Avrupa, Orta Doğu ve ötesinde gerçekleştirdiğimiz en etkileyici etkinliklerimizden bir seçki.
            </p>
          </div>

          <PortfolioLightbox lang="tr" items={TR_PORTFOLIO} />

          <div className="mt-16 text-center">
            <h3 className="text-xl font-semibold text-white mb-4">Projelerimiz Hakkında Daha Fazla Bilgi Almak İster misiniz?</h3>
            <p className="text-gray-300 mb-6">Projelerimiz hakkında detaylı bilgi almak için aşağıdaki iletişim bilgilerinden bize ulaşabilirsiniz.</p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-black">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Bizimle
              <span className="text-yellow-400"> İletişime Geçin</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Vizyonunuzu unutulmaz bir deneyime dönüştürmeye hazır mısınız? Bir sonraki etkinliğinizi birlikte konuşalım.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div className="space-y-6">
              <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-xl p-6">
                <h4 className="text-xl font-semibold mb-4 text-yellow-400">Global Erişim</h4>
                <p className="text-gray-300 mb-4">Faaliyet gösterdiğimiz ülkeler:</p>
                <div className="flex flex-wrap gap-2">
                  {['Türkiye', 'Macaristan', 'Suudi Arabistan', 'Gürcistan', 'Azerbaycan', 'Avusturya', 'BAE', 'Yunanistan', 'Portekiz', 'Almanya', 'Dubai', 'Çek Cumhuriyeti', 'Sırbistan', 'İspanya', 'Fransa', 'Hollanda', 'İtalya', 'İngiltere'].map((country) => (
                    <span key={country} className="bg-yellow-400/10 text-yellow-400 px-3 py-1 rounded-full text-sm">{country}</span>
                  ))}
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <div className="bg-gradient-to-br from-yellow-400/10 to-yellow-500/5 border border-yellow-400/30 rounded-xl p-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex-shrink-0 bg-yellow-400 rounded-xl flex items-center justify-center">
                    <i className="ri-file-text-line text-xl text-black"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-white mb-1">Özel Teklif Alın</h3>
                    <p className="text-gray-400 text-sm mb-4">Etkinliğinizi anlatın, 24 saat içinde size özel bir teklif hazırlayalım.</p>
                    <button
                      onClick={() => setIsQuoteOpen(true)}
                      className="w-full py-3 bg-yellow-400 text-black font-bold rounded-lg hover:bg-yellow-300 transition-all duration-300 hover:scale-[1.02] cursor-pointer flex items-center justify-center gap-2 text-sm whitespace-nowrap"
                    >
                      <i className="ri-send-plane-line"></i>
                      Teklif Talep Et
                    </button>
                  </div>
                </div>
              </div>

              <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-xl p-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex-shrink-0 bg-gray-800 border border-gray-700 rounded-xl flex items-center justify-center">
                    <i className="ri-phone-line text-xl text-yellow-400"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-white mb-1">Konuşmayı Tercih Eder misiniz?</h3>
                    <p className="text-gray-400 text-sm mb-4">Hızlı bir görüşme için telefon veya WhatsApp ile doğrudan bize ulaşın.</p>
                    <button
                      onClick={handleCallClick}
                      className="w-full py-3 border border-gray-600 text-gray-200 font-semibold rounded-lg hover:border-yellow-400/50 hover:text-yellow-400 transition-all duration-300 cursor-pointer flex items-center justify-center gap-2 text-sm whitespace-nowrap"
                    >
                      <i className="ri-phone-line"></i>
                      Hemen Ara
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-12">
            <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-xl p-6">
              <h3 className="text-xl font-semibold mb-4 text-yellow-400">İstanbul Ofisi</h3>
              <div className="space-y-3 text-gray-300">
                <div className="flex items-start">
                  <i className="ri-building-line text-yellow-400 mr-3 mt-1"></i>
                  <div>
                    <div className="font-medium">CSG Etkinlik Yönetim ve Teknik Prodüksiyon Hizmetleri A.Ş.</div>
                    <div>Tomtom Mah. İstiklal Cad. No:189 Kat:2 Daire:3</div>
                    <div>Beyoğlu/İstanbul, Türkiye</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-xl p-6">
              <h3 className="text-xl font-semibold mb-4 text-yellow-400">Budapeşte Ofisi</h3>
              <div className="space-y-3 text-gray-300">
                <div className="flex items-start">
                  <i className="ri-building-line text-yellow-400 mr-3 mt-1"></i>
                  <div>
                    <div className="font-medium">IEM101 International Kft.</div>
                    <div>Föld utca 53</div>
                    <div>1032 Budapeşte, Macaristan</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Showreel Section */}
      <ShowreelSection
        subtitle="Çalışmalarımızı İzleyin"
        title="Büyüyü Hareket Halinde Görün"
        description="Büyük sahnelerden samimi buluşmalara — etkinlikleri hassasiyet, yaratıcılık ve tutku ile nasıl hayata geçirdiğimizi izleyin."
        ctaLabel="Showreel'i Oynat"
        closeHint="ESC tuşuna basın veya dışarı tıklayarak kapatın"
      />

      <QuoteModal isOpen={isQuoteOpen} onClose={() => setIsQuoteOpen(false)} lang="tr" />

      {/* Service Detail Modal */}
      <ServiceModal
        service={selectedService}
        onClose={() => setSelectedService(null)}
        ctaLabel="Teklif Talep Et"
        onCtaClick={() => setIsQuoteOpen(true)}
      />

      {/* Call Options Modal */}
      {showCallOptions && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-gray-900 border border-gray-700 rounded-2xl p-8 max-w-md w-full">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">Bizi Arayın</h3>
              <p className="text-gray-400">Nasıl iletişime geçmek istersiniz?</p>
            </div>
            <div className="space-y-3">
              <button onClick={handlePhoneCall} className="w-full bg-green-600 hover:bg-green-700 text-white py-3 px-4 rounded-lg flex items-center justify-center space-x-3 transition-colors cursor-pointer">
                <i className="ri-phone-line text-xl"></i><span>Sesli Arama</span>
              </button>
              <button onClick={handleWhatsAppCall} className="w-full bg-green-500 hover:bg-green-600 text-white py-3 px-4 rounded-lg flex items-center justify-center space-x-3 transition-colors cursor-pointer">
                <i className="ri-whatsapp-line text-xl"></i><span>WhatsApp</span>
              </button>
              <button onClick={() => setShowCallOptions(false)} className="w-full bg-gray-700 hover:bg-gray-600 text-white py-3 px-4 rounded-lg transition-colors cursor-pointer">
                İptal
              </button>
            </div>
          </div>
        </div>
      )}



      <Footer lang="tr" />
    </div>
  );
}
